import ChartFromReadyToHire from './ChartFromReadyToHire.container';

export default ChartFromReadyToHire;
